import styled from 'styled-components';
import HyperLink from 'components/Core/HyperLink';
import { STLogo } from 'components/Brand/Logos/STLogo';
import { Row } from 'components/Core/Grid';

export const FooterWrapper = styled.footer`
  background: var(--darkest);
  margin-bottom: -25px;
  padding: 24px 28px;

  @media (max-width: 767px) {
    padding: 24px 20px;
  }

  .footer--bottom-item {
    color: var(--white);
  }
  .footer--copyright {
    color: var(--white);
  }
  .footer--menu-item-title {
    font-family: var(--font-family-heading);
    color: var(--white);
  }
`;

export const InnerContainer = styled.div`
  max-width: var(--max-width);
  margin: 0px auto;

  @media (min-width: 1200px) {
    padding: 0 20px;
  }

  @media (max-width: 767px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const STFooterLogo = styled(STLogo)`
  margin-top: 40px;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    width: 178px;
    margin-top: 16px;
    margin-bottom: 28px;
  }
`;

export const FooterBody = styled(Row)`
  background: transparent;
  color: var(--grey-8);
  padding-top: 20px;
  border: 0;

  .footer--mobile-menu-column {
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    .MuiGrid-item {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }

  @media (max-width: 991px) {
    .MuiGrid-item {
      padding-bottom: 30px;
    }
  }

  @media (max-width: 575px) {
    padding-top: 0px;
  }
`;

export const Title = styled.div`
  font-size: var(--font-size-h5);
  padding-bottom: 30px;
  font-weight: var(--font-weight-900);
  line-height: var(--line-height-120);
  letter-spacing: var(--letter-spacing--0-02);

  @media (max-width: 991px) {
    font-size: var(--font-size-20);
    padding-bottom: 15px;
  }
  @media (max-width: 575px) {
    margin-top: 20px;
  }
`;

export const MenuItemLink = styled(HyperLink)`
  color: var(--white);
  display: block;
  line-height: var(--line-height-100);
  padding-bottom: 16px;

  &:hover {
    color: var(--grey-6);
  }

  @media (max-width: 991px) {
    font-size: var(--font-size-13);
  }

  @media (max-width: 767px) {
    font-size: var(--font-size-16);
    line-height: var(--line-height-130);
    padding-bottom: 15px;
  }
`;

export const Line = styled.div`
  margin: 40px 0;
  border-top: 1px solid var(--dark);
  @media (max-width: 540px) {
    margin: 20px 0;
  }
`;

export const FooterBottom = styled.div`
  margin: 40px 0 64px;
  color: var(--white);

  .ot-cookie-setting-btn {
    position: relative;

    p {
      color: white !important;
      font-size: 13px !important;
      margin: 0 !important;

      @media (max-width: 767px) {
        text-align: center;
        font-size: 14px !important;
        width: 100% !important;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  .footer-social-container {
    display: flex;
    flex-direction: column-reverse;
  }

  @media (min-width: 926px) {
    .footer-social-container {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  @media (max-width: 926px) {
    flex-direction: column-reverse;
    flex-flow: wrap-reverse;
    align-items: self-start;
    justify-content: space-between;
    margin: 10px 0 0;
  }
`;

export const Copyright = styled.div`
  color: var(--grey-8);
  font-size: 13px;
  @media (max-width: 767px) {
    line-height: 150%;
    font-size: 14px;
  }
`;

export const BottomItem = styled(HyperLink)`
  font-size: 13px;
  display: inline-block;

  &:hover {
    color: var(--grey-3);
  }

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 150%;
  }
`;

export const SocialIcons = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: 0 20px;

  svg {
    color: #fff;
    width: 30px;
    height: 30px;
  }
  @media (max-width: 1024px) {
    margin-bottom: 30px;
    justify-content: space-evenly;
  }
`;

export const IconItem = styled(HyperLink)``;

export const FooterBottomMenu = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: var(--font-size-13);
  gap: 15px;
  align-items: center;
  justify-content: center;

  .footer-body-items {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  @media (max-width: 926px) {
    flex-direction: column-reverse;
    align-items: center;
    .footer-body-items {
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }
  }
`;

export const FormContainer = styled.div`
  width: 40%;
  .subscribe-form--footer-legal-info {
    opacity: 1;

    p {
      color: ${({ theme }) => (theme === 'light' ? 'var(--white)' : 'var(--darkest)')};
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
    }
  }

  .marketo-form {
    & > div {
      box-shadow: none !important;
    }
  }

  @media (max-width: 926px) {
    width: 100%;
    padding-bottom: 60px;
    > div {
      padding: 0;
    }

    .marketo-form {
      & > div {
        padding: 16px 0;
      }
    }
  }

  @media (max-width: 575px) {
    .dynamic-form--container {
      height: auto;
    }

    & > div:first-child {
      text-align: center;
    }
  }
`;
